<div class="row" *ngIf="s.required && s.visible">
  <div class="col-12">
    <div class="row task" id="{{ s.id }}">
      <div
        class="col-12 pb-1 pt-1 d-flex"
        [ngClass]="{
          completed:
            task.isCompleted &&
            (task.component?.type == 0 || task.component?.type == 1),
          'not-completed':
            !task.isCompleted &&
            (task.component?.type == 0 || task.component?.type == 1),
        }"
      >
        <master-control
          *ngIf="!resetting"
          class="full-width"
          [s]="s"
          [id]="s.id"
          [code]="s.code"
          [formType]="currentChecklist?.documentType?.code"
          [serialNo]="currentChecklist?.serialNo"
          [type]="s.type"
          [builder]="false"
          [enabled]="s.enabled"
          [serialNo]="currentChecklist?.serialNo"
          [formType]="currentChecklist?.documentType?.code"
          [visible]="s.visible && s.required"
          [disabled]="s.disabled || disabledClose(s) || saving"
          [disableEdit]="s.disableEdit"
          [saving]="saving"
          [currentChecklist]="currentChecklist"
          [currentChecklistTemplate]="currentChecklistTemplate"
          [color]="color"
          [number]="s.number"
          [header]="s.name"
          [label]="s.name"
          [text]="s.question"
          [question]="s.question"
          [radioQuestion]="s.question2"
          [radioSelection]="s.value2"
          [radioOptions]="s.options"
          [options]="s.options"
          [checkbox_checked]="s.approved"
          [showApprove]="s.approveAction"
          [approved]="s.approved"
          [suggested]="s.suggested ?? false"
          [suggestionReason]="s.suggestionReason"
          [approvedBy]="s.approvedBy"
          [approvedOn]="s.approvedOn"
          [showUnapprove]="s.unapproveAction"
          [showDisapprove]="s.disapproveAction && !s.approved"
          [roleIds]="s.roles"
          [roleCodes]="s.roleCodes"
          [scheduleResourceId]="s.scheduleResourceId"
          [textBefore]="
            s.type == 39
              ? null
              : s.type == 6 || s.type == 8 || s.type == 9 || s.type == 24
                ? s.question2
                : s.question
          "
          [textAfter]="
            s.type == 6 || s.type == 8 || s.type == 9 || s.type == 24
              ? s.question
              : s.question2
          "
          [textAfter2]="s.question3"
          [textValue]="s.textValue"
          [checkboxVisible]="s.visible != undefined ? s.visible : true"
          [dateValue1]="s.dateValue1"
          [dateValue2]="s.dateValue2"
          [dateValue3]="s.dateValue3"
          [scheduleTypeId]="s.scheduleTypeId"
          [scheduleResourceId]="s.scheduleResourceId"
          [scheduleName]="s.scheduleName"
          [configuration]="s.configuration"
          [sectionNumber]="section?.number"
          [sectionId]="section?.id"
          [editMode]="s.editMode"
          [resourceID]="task.resourceId"
          [taskId]="s.id"
          [booleanValue]="s.booleanValue"
          (changed)="change($event, s.id)"
          (save)="
            save($event, s.id, s.taskId, s.approveActionId, s.unapproveActionId)
          "
          (checked)="
            check($event, s.taskId, s.approveActionId, s.unapproveActionId)
          "
          (approve)="sign($event, s.taskId, s.approveActionId)"
          (unapprove)="sign($event, s.taskId, s.unapproveActionId)"
          (disapprove)="sign($event, s.taskId, s.disapproveActionId)"
          (duplicate)="duplicate($event)"
          (checkShared)="checkShared.emit($event)"
          (close)="close()"
          (itemCountChanged)="
            task.itemCount = $event; itemCountChanged.emit($event)
          "
        >
        </master-control>
        <div
          class="indicator no-print d-flex flex-column justify-content-center"
          *ngIf="s.code || s.condition || s.sigCondition"
        >
          <div>
            <mat-icon
              class="small-icon"
              color="accent"
              *ngIf="s.code"
              [matTooltip]="s.code"
              >local_offer</mat-icon
            >
          </div>
          <div>
            <mat-icon
              class="purple material-symbols-outlined small-icon"
              color="accent"
              *ngIf="s.sigCondition"
              [matTooltip]="s.sigCondition"
              >arrow_split</mat-icon
            >
          </div>
          <div>
            <mat-icon
              class="pink small-icon"
              *ngIf="s.condition"
              [matTooltip]="s.condition"
              >device_hub</mat-icon
            >
          </div>
        </div>
      </div>
      <div
        class="rcp-actions"
        *ngIf="
          task.component?.type == 1 &&
          currentChecklist?.checklistTemplate?.templateType?.allowActionItems
        "
      >
        <checklist-task-rcpactions
          [task]="task"
          [s]="s"
          [currentChecklist]="currentChecklist"
        ></checklist-task-rcpactions>
      </div>

      <checklist-task-review
        class="review"
        *ngIf="
          currentChecklist?.checklistStatus?.formStatusID ==
            formStatus.Reviewing &&
          isReviewer() &&
          stepStatusCorrecting(task)
        "
        [s]="s"
        [currentChecklist]="currentChecklist"
        [task]="task"
        (changed)="annotationsChanged($event)"
      ></checklist-task-review>
      <checklist-task-actionitems
        class="action-items"
        *ngIf="
          task.component?.type == 1 &&
          currentChecklist?.checklistTemplate?.templateType?.allowActionItems
        "
        [task]="task"
        [currentChecklist]="currentChecklist"
      ></checklist-task-actionitems>
      <checklist-tasks-annotations
        class="annotations"
        [task]="task"
        [currentChecklist]="currentChecklist"
        [s]="s"
        (changed)="annotationsChanged($event)"
        *ngIf="
          currentChecklist?.checklistStatus?.formStatusID != formStatus.Draft ||
          currentChecklist?.checklistTemplate?.documentTypeID == 200
        "
      ></checklist-tasks-annotations>
    </div>
  </div>
  <!-- <div
    class="col-2 pl-0"
    *ngIf="currentChecklist?.checklistTemplate?.templateType?.code == 'BAR'"
  >
    <checklist-task-review-satisfaction-check
      [task]="task"
      [checklist]="currentChecklist"
      [precheck]="precheck"
    ></checklist-task-review-satisfaction-check>
  </div> -->
</div>
